export type RemoteSupportWidgetVariant = 'general' | 'remote'

export interface RemoteSupportWidgetConfig {
  src: string;
  id: string;
  staticDataAttributes: Record<string, string>;
}

const SCRIPT_SRC = 'https://solve-widget.forethought.ai/embed.js'
const SCRIPT_ID = 'forethought-widget-embed-script'
const API_KEY = 'c1bd2e68-6d9b-4da6-b5b4-c38dd6edc55f'

// Per-variant attributes fixed regardless of who's logged in. The remaining data-ft-*
// attributes (account-Id, Email, Full-Name) are derived from the current admin user at mount
// time - see RemoteSupportWidgetService.mount.
export const remoteSupportWidgetConfig: Record<RemoteSupportWidgetVariant, RemoteSupportWidgetConfig> = {
  general: {
    src: SCRIPT_SRC,
    id: SCRIPT_ID,
    staticDataAttributes: {
      'data-api-key': API_KEY,
      'data-ft-workflow-tag': 'A2ZRegTechBasic'
    }
  },
  remote: {
    src: SCRIPT_SRC,
    id: SCRIPT_ID,
    staticDataAttributes: {
      'data-api-key': API_KEY,
      'data-ft-workflow-tag': 'A2ZRegTech'
    }
  }
}
